<div class="navbar">
    <div routerLink = "">
        <span>Accueil</span>
        <div class="groupBubble">
            <div class="bubble quatre"></div>
            <div class="bubble trois"></div>
            <div class="bubble deux"></div>
            <div class="bubble un"></div>
        </div>
    </div>
    <div routerLink="agenda">
        <span>Contact</span>
        <div class="groupBubble">
            <div class="bubble quatre"></div>
            <div class="bubble trois"></div>
            <div class="bubble deux"></div>
            <div class="bubble un"></div>
        </div>
    </div>
    <div routerLink= "adresses">
        <span>Adresses</span>
        <div class="groupBubble">
            <div class="bubble un"></div>
            <div class="bubble deux"></div>
            <div class="bubble trois"></div>
            <div class="bubble quatre"></div>
        </div>
    </div>
    <div routerLink="infos">
        <span>Infos</span>
        <div class="groupBubble">
            <div class="bubble un"></div>
            <div class="bubble deux"></div>
            <div class="bubble trois"></div>
            <div class="bubble quatre"></div>
        </div>
    </div>
</div>
